














import { VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from 'vuetify/lib'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'base-expansion-panel',
  components: {
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent
  }
})
